export const getNotificationCount = (notifications) => {
  return notifications?.filter((item) => !item.is_read).length;
};
